export enum PropertyType {
    Status,
    ExitUrl,
    Relative,
    Question,
    AutoClean,
    CalculatedVariableName,
    Variable,
    ValueType,
    Value,
    Block,
    MatrixIndex,
    Mode,
    // Selection
    InclusionFormula,
    ScoreFormula,
    Priority,
    AffectedRow,
    Mention,
    SelectionCount,
    // Email
    From,
    To,
    ReplyTo,
    Subject,
    Body,
    // Slider
    CursorColor,
    CursorURL,
    SliderBarColor,
    SliderBarTrailingColor,
    SliderBarURL,
    LeftAnchorURL,
    RightAnchorURL,
}
